
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/privacy",
      function () {
        return require("private-next-pages/[lang]/privacy/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/privacy"])
      });
    }
  